var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWantedActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9591 0C22.1855 0 24 1.81447 24 4.05067V6.11729V17.8897V19.9493C24 22.1855 22.1855 24 19.9591 24H4.04087C1.81447 24 0 22.1855 0 19.9493V17.8897V6.11729V4.05067C0 1.81447 1.81447 0 4.04087 0H19.9591ZM1.76543 5.55367V17.8878C1.76543 17.8884 1.76543 17.889 1.76543 17.8897V19.9493C1.76543 21.0521 2.54638 21.9747 3.58265 22.1881C3.73069 22.2186 3.88394 22.2346 4.04087 22.2346H19.9591C21.2145 22.2346 22.2346 21.2096 22.2346 19.9493L22.2346 17.8897C22.2346 17.889 22.2346 17.8884 22.2346 17.8878V6.11729V4.05067C22.2346 2.79036 21.2145 1.76543 19.9591 1.76543H4.04087C3.09931 1.76543 2.29015 2.34195 1.94442 3.16191C1.82918 3.43523 1.76543 3.73559 1.76543 4.05067L1.76543 5.55367Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1945 16.4945C14.0634 16.4945 16.3891 14.1452 16.3891 11.2472C16.3891 8.34927 14.0634 6 11.1945 6C8.32567 6 6 8.34927 6 11.2472C6 14.1452 8.32567 16.4945 11.1945 16.4945ZM11.1945 14.9953C13.2437 14.9953 14.9049 13.3172 14.9049 11.2472C14.9049 9.17726 13.2437 7.49921 11.1945 7.49921C9.14535 7.49921 7.48415 9.17726 7.48415 11.2472C7.48415 13.3172 9.14535 14.9953 11.1945 14.9953Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7673 17.6787C19.1184 17.275 19.066 16.6571 18.6519 16.3196L18.41 16.1225L15.6861 13.8182C15.2951 13.4819 14.6896 13.5126 14.3337 13.8867C13.9776 14.2609 14.0062 14.8368 14.3971 15.1731L17.4623 17.7781C17.8517 18.109 18.4315 18.0649 18.7673 17.6787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWantedActive);
export default __webpack_public_path__ + "static/media/wanted-active.29bea2aee6e9bbe1b0ce21070aec7c4b.svg";
export { ForwardRef as ReactComponent };